"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

var _resizerIds = require("../../../../../constants/resizerIds");

require("../styles/_clip-overlay.scss");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ClipOverlay(_ref) {
  var isDragging = _ref.isDragging,
      isHovered = _ref.isHovered,
      onMouseDown = _ref.onMouseDown,
      handleDeleteClip = _ref.handleDeleteClip,
      onSnapClip = _ref.onSnapClip,
      onSnapMultipleClips = _ref.onSnapMultipleClips,
      clip = _ref.clip;

  if (!isHovered && !isDragging) {
    return null;
  }

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "clip-overlay"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "clip-overlay__actions"
  }, /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
    className: "clip-overlay__actions__push-left",
    name: "arrowleft",
    size: 11,
    color: "white",
    onClick: onSnapClip(clip.clipId)
  }), /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
    className: "clip-overlay__actions__push-all-left",
    name: "rewind",
    size: 15,
    color: "white",
    onClick: onSnapMultipleClips(clip.clipId)
  }), /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
    className: "clip-overlay__actions__delete-clip",
    name: "trash",
    size: 15,
    color: "white",
    onClick: handleDeleteClip
  })), /*#__PURE__*/_react.default.createElement("div", {
    role: "button",
    tabIndex: 0,
    id: _resizerIds.LEFT_RESIZER_ID,
    onMouseDown: onMouseDown,
    className: "clip-overlay__left-resize"
  }), /*#__PURE__*/_react.default.createElement("div", {
    role: "button",
    tabIndex: 0,
    id: _resizerIds.RIGHT_RESIZER_ID,
    onMouseDown: onMouseDown,
    className: "clip-overlay__right-resize"
  }));
}

var _default = /*#__PURE__*/(0, _react.memo)(ClipOverlay);

exports.default = _default;